//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';
import P2PDeals from '../P2POffersAndDeals/P2PDeals/P2PDeals.vue';
import P2POffers from '../P2POffersAndDeals/P2POffers/P2POffers.vue';
import AccountInfo from './AccountInfo.vue';
import Reviews from './UserP2PReviews/UserP2PReviews.vue';
import Requisites from './UserP2PRequisites/UserP2PRequisites.vue';


export default {
  components: {
    AccountInfo,
    P2PDeals,
    P2POffers,
    Reviews,
    Requisites,
  },

  computed: {
    ...mapState('user', ['user']),
    routerId() {
      return this.$route.params.id;
    },
  },

  async created() {
    const routerId = this.$route.params.id;
    this.setGeneralLoader(true);
    if (routerId) {
      await Promise.allSettled([
        this.loadP2pDeals({
          userId: routerId,
        }),
        this.loadP2POffers({
          authorId: routerId,
        }),
        this.loadUserP2PData({
          id: routerId,
        }),
        this.loadRequisitesData(),
        this.loadP2pCurrencies(),
        this.loadP2pPaymentMethods(),
      ]);
    }
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('p2pDeals', {
      loadP2pDeals: 'loadData',
    }),
    ...mapActions('p2pOffers', {
      loadP2POffers: 'loadData',
    }),
    ...mapActions('userP2P', {
      loadUserP2PData: 'loadUserP2PData',
    }),
    ...mapActions('p2p', ['loadP2pCurrencies', 'loadP2pPaymentMethods']),
    ...mapActions('userP2PRequisites', {
      loadRequisitesData: 'loadData',
    }),
  },
};
